var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "span",
    {
      staticClass: "activefilter",
    },
    [
      _vm._t("default"),
      _vm._v(" "),
      _c(
        "button",
        {
          attrs: {
            type: "button",
            title: _vm.$gettextInterpolate(
              _vm.$gettext("Filter '%{name}' entfernen"),
              {
                name: _vm.name,
              },
              true
            ),
          },
          on: {
            click: _vm.onRemoveActiveFilter,
          },
        },
        [
          _c("StudipIcon", {
            staticClass: "text-bottom",
            attrs: {
              shape: "decline",
              role: "presentation",
              alt: "",
            },
          }),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }